module.exports = __webpack_public_path__ + "img/card-bg.40d69bf2.png";